import { Fragment } from 'react';
import { mediaQurey, zIndex } from 'helper/Style';
import Head from 'component/part/Head';
import Header from 'component/part/Header';
import Menu from 'component/part/Menu';

export type LayoutProps = Readonly<{
  children: React.JSX.Element | React.JSX.Element[];
}>;

const style = {
  layout: {
    // 100vw だと Windows Chrome 等でスクロールバー幅分のはみ出しが起きて横スクロールバーが出るため、body の利用可能幅を継承する 100% を使う
    width: '100%',
    // viewport 高さで打ち止め、内部は flex column。List ページが List 内部スクロールを成立させるために必要。
    height: '100vh',
    display: 'flex',
    flexDirection: 'column' as const,
    overflow: 'hidden' as const,
    fontSize: '1.6rem',
  },
  header: {
    width: '100%',
    height: '3.6rem',
    flexShrink: 0,
    zIndex: zIndex.header,
  },
  content: {
    position: 'relative' as const,
    display: 'flex',
    width: '100%',
    flex: '1 1 auto',
    minHeight: 0,
    [mediaQurey('max', 'sp')]: {
      display: 'initial',
    },
  },
  menuArea: {
    backgroundColor: '#ffffff',
    zIndex: zIndex.menu,
    [mediaQurey('min', 'pc')]: {
      // 親 (.content) 自体が高さ固定なので sticky 不要。flex 子として全高を埋める
      height: '100%',
      // 内部スクロールを成立させるため、コンテンツ高さで伸びないよう min-height は 0 にする
      minHeight: 0,
    },
    [mediaQurey('max', 'tablet')]: {
      position: 'fixed' as const,
      top: '3.6rem',
      left: '0',
      // fixed の height:100% は 100vh 基準になり、top:3.6rem 分だけ下端がはみ出して
      // スクロール領域の最下部が画面外に残ってしまうため、ヘッダー高さ(3.6rem)を差し引く
      height: 'calc(100% - 3.6rem)',
    },
  },
  mainArea: {
    flex: '1 1 auto',
    minWidth: 0,
    minHeight: 0,
    // 通常 (Edit など): mainArea 内で縦スクロール。
    // List ページは内部の wrapper が flex: 1 + min-height: 0 でこのスクロールを吸収し、List 内部スクロールに切り替わる。
    display: 'flex',
    flexDirection: 'column' as const,
    overflowX: 'hidden' as const,
    overflowY: 'auto' as const,
    padding: '2rem 4rem',
    // SP は親 .content が display: initial (block) になるため flex から高さを得られない。
    // .content 自身は .layout の flex item として算定高さを持つので height: 100% で参照して overflowY: auto を成立させる。
    [mediaQurey('max', 'sp')]: {
      height: '100%',
    },
  },
};

const Layout = (props: LayoutProps) =>
  <Fragment>
    <Head />
    <div css={style.layout}>
      <Header css={style.header} />
      <div css={style.content}>
        <Menu css={style.menuArea} />
        <div css={style.mainArea}>
          {props.children}
        </div>
      </div>
    </div>
  </Fragment>;

export default Layout;
